// import logo from './logo.svg';
import './App.css';
import './lib/animate/animate.min.css';
import './lib/lightbox/css/lightbox.min.css';
import './lib/owlcarousel/assets/owl.carousel.min.css';
import './css/bootstrap.min.css';
import './css/style.css';
import about2 from './img/about-2.png';
import about3 from './img/about-3.png';
import about4 from './img/about-4.png';
import about5 from './img/about-5.jpg';
import service1 from './img/service-1.jpg';
import service2 from './img/service-2.jpg';
import service3 from './img/service-3.jpg';
import service4 from './img/service-4.jpg';
import service5 from './img/service-5.jpg';
import service6 from './img/service-6.jpg';

import axios from "axios";


// src/App.js
import React, { useEffect } from 'react';
import NAV from "./pages/nav";
import Carousel from "./pages/carousel";
import TrendingNewsScroller from "./components/newsscroll"
import LiveMarketOverview from "./components/marketsnap";
import PriceScroller from "./components/pricescroll";
import PopupNotice from "./components/popupnotice";
import MarketCommentaryBanner from "./components/blog/market_commentary_banner"
import VideoModal from "./components/ui/video";
import FloatingAnnouncements from "./components/ui/FloatingAnnouncements";
import {useNavigate} from "react-router-dom";
import TopMoversHeatmap from "./components/movers";
import IntradayHeatmap from "./components/stocks/intraday_heatmap";
import IntradayBubbleMap from "./components/stocks/intraday_pv";
import HighLowVolatilityChart from "./components/stocks/intraday_vol";
import MarketIndices from "./components/markets/market_indices";



function HomePage() {

  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const requestToken = urlParams.get('request_token');
    const status = urlParams.get('status');
    if (requestToken && status === 'success') {
        console.log("TOKEN  ->",requestToken)
      // Call your Django backend to validate or use the token
      axios.get(`/api/kite-login/?request_token=${requestToken}`)
        .then(response => {
          alert('Login successful!');
        })
        .catch(error => {
          console.error(error);
          alert('Login failed. Please try again.');
        })
        .finally(() => {
          // Always redirect to homepage cleanly
          navigate('/', { replace: true });
        });
    }
  }, [navigate]);


   return (
      <div>
      <PopupNotice/>
      <div className="container-fluid position-relative p-0">
        <NAV activetag="home"/>
        <Carousel activetag="home"/>
        <TrendingNewsScroller/>
        <PriceScroller/>

          <div className="container-fluid service pb-5" >
                  {/*<div className="container pb-1">*/}
                  <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s">
                     <FloatingAnnouncements/>
                     <MarketCommentaryBanner/>
                     <LiveMarketOverview/>
                      <MarketIndices/>
	   {/*<VideoModal/>*/}
                  </div>
                  {/*</div>*/}
          </div>
      </div>

      {/*<div className="container-fluid about py-5"/>*/}

        {/*<!-- Top Stock Movers Start -->*/}
        <div className="container-fluid service py-5">
            <div className="container py-5">
                {/*<div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s"*/}
                {/*     style={{maxwidth: '800px'}}>*/}
                {/*    /!*<h4 class="text-primary">Our Services</h4>*!/*/}
                {/*    <h5 className="display-5 mb-4">Top Stock Movers </h5>*/}
                {/*    /!*<p class="mb-0">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur adipisci facilis cupiditate recusandae aperiam temporibus corporis itaque quis facere, numquam, ad culpa deserunt sint dolorem autem obcaecati, ipsam mollitia hic.*!/*/}
                {/*    /!*</p>*!/*/}
                {/*</div>*/}
                <div className="row g-4">

                    <div className="col-md-6 col-lg-6 wow fadeInUp" data-wow-delay="0.6s">
                        <div className="service-item" align={'center'}>
                           <TopMoversHeatmap  symbol={'NIFTY 100'} chartType={'barchart'}/>
	   		</div>
                    </div>
                    <div className="col-md-6 col-lg-6 wow fadeInUp" data-wow-delay="0.6s">
                        <div className="service-item" align={'center'}>
	                   <TopMoversHeatmap symbol={'sectors'} chartType={'barchart'}/>
                        </div>
                    </div>
                    {/*<div className="col-md-12 col-lg-12 wow fadeInUp" data-wow-delay="0.6s">*/}
                </div>
                    {/*</div>*/}


                    {/*<div className="col-md-12 col-lg-12 wow fadeInUp" data-wow-delay="0.6s">*/}
                <div className="row g-4">

                    <div className="col-md-6 col-lg-6 wow fadeInUp" data-wow-delay="0.6s">
                        <div className="service-item" align={'center'}>
                            <IntradayBubbleMap/>
                        </div>
                    </div>

                    <div className="col-md-6 col-lg-6 wow fadeInUp" data-wow-delay="0.6s">
                        <div className="service-item" align={'center'}>
                            <HighLowVolatilityChart/>
                        </div>
                    </div>

                    {/*<div className="col-md-12 col-lg-12 wow fadeInUp" data-wow-delay="0.6s">*/}
                </div>
            </div>
        </div>
        {/*<!-- Top Stock Movers End -->*/}


      {/*<!-- Services Start -->*/}

      <div className="container-fluid service pb-5" id={"services_section"}>
              <div className="container pb-5">
              <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxwidth: "800px"}}>
                  <h4 className="text-primary">Our Services</h4>
                  <h1 className="display-5 mb-4">Key Features Overview</h1>
                  {/*<p className="mb-0">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur adipisci facilis*/}
                  {/*    cupiditate recusandae aperiam temporibus corporis itaque quis facere, numquam, ad culpa deserunt*/}
                  {/*    sint dolorem autem obcaecati, ipsam mollitia hic.*/}
                  {/*</p>*/}
              </div>
              <div className="row g-4">
                              <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.2s">
                                  <div className="service-item">
                                      <div className="service-img">
                                          <img src={service1} className="img-fluid rounded-top w-100" alt="Image"/>
                                      </div>
                                      <div className="rounded-bottom p-4">
                                          <a href="/stock/" className="h4 d-inline-block mb-4"> Stock Market Analysis</a>
                                          <p className="mb-4"> Comprehensive System with  Interactive charts, Historical data,Correlation tools, Sector analysis.
                                          </p>
                                          <a className="btn btn-primary rounded-pill py-2 px-4" href="/stock/">Learn More</a>
                                      </div>
                                  </div>
                              </div>
                              <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.4s">
                                  <div className="service-item">
                                      <div className="service-img">
                                          <img src={service2} className="img-fluid rounded-top w-100" alt="Image"/>
                                      </div>
                                      <div className="rounded-bottom p-4">
                                          <a href="/ia/" className="h4 d-inline-block mb-4">Financial Advisory</a>
                                          <p className="mb-4">Stock & Derivative Strategies, Payoff simulations, Risk management strategies.

                                          </p>
                                          <a className="btn btn-primary rounded-pill py-2 px-4" href="/ia/">Learn More</a>
                                      </div>
                                  </div>
                              </div>
                              <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.6s">
                                  <div className="service-item">
                                      <div className="service-img">
                                          <img src={service3} className="img-fluid rounded-top w-100" alt="Image"/>
                                      </div>
                                      <div className="rounded-bottom p-4">
                                          <a href="/ra/" className="h4 d-inline-block mb-4">Risk Management</a>
                                          <p className="mb-4">Sensitivity Analysis, Scenario Analysis, VaR, Attribution
                                          </p>
                                          <a className="btn btn-primary rounded-pill py-2 px-4" href="/ra/">Learn More</a>
                                      </div>
                                  </div>
                              </div>
                              <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.2s">
                                  <div className="service-item">
                                      <div className="service-img">
                                          <img src={service4} className="img-fluid rounded-top w-100" alt="Image"/>
                                      </div>
                                      <div className="rounded-bottom p-4">
                                          <a href="portfolio/" className="h4 d-inline-block mb-4">Portfolio Analytics</a>
                                          <p className="mb-4">Portfolio Services, Real-time PnL tracking, Advanced analytics,
                                              Scenarios, Portfolio Sensitivity
                                          </p>
                                          <a className="btn btn-primary rounded-pill py-2 px-4" href="/portfolio/">Learn More</a>
                                      </div>
                                  </div>
                              </div>
                              <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.4s">
                                  <div className="service-item">
                                      <div className="service-img">
                                          <img src={service5} className="img-fluid rounded-top w-100" alt="Image"/>
                                      </div>
                                      <div className="rounded-bottom p-4">
                                          <a href="/ra/" className="h4 d-inline-block mb-4">Fixed Income Analytics</a>
                                          <p className="mb-4">Bond pricing, interest rate curves, Sensitivity analysis.
                                          </p>
                                          <a className="btn btn-primary rounded-pill py-2 px-4" href="/ra/">Learn More</a>
                                      </div>
                                  </div>
                              </div>
                              <div className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.6s">
                                  <div className="service-item">
                                      <div className="service-img">
                                          <img src={service6} className="img-fluid rounded-top w-100" alt="Image"/>
                                      </div>
                                      <div className="rounded-bottom p-4">
                                          <a href="/research/" className="h4 d-inline-block mb-4">AI-Powered Insights</a>
                                          <p className="mb-4">Intelligent recommendations and dynamic optimizations.
                                          </p>
                                          <a className="btn btn-primary rounded-pill py-2 px-4" href="/research/">Learn More</a>
                                      </div>
                                  </div>
                              </div>
              </div>
          </div>
      </div>

    {/*<!-- Services End -->*/}

       {/* <!-- Features Start -->*/}
        <div class="container-fluid feature pb-5" id={"target_section"}>
            <div class="container pb-5">
                <div class="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxwidth: "800px"}}>
                    <h4 class="text-primary">Who Is It For? (Target Audience Section)</h4>
                    <h1 class="display-5 mb-4">Solutions for a wide spectrum of Investment Professionals </h1>
                    {/*<p class="mb-0">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur adipisci facilis cupiditate recusandae aperiam temporibus corporis itaque quis facere, numquam, ad culpa deserunt sint dolorem autem obcaecati, ipsam mollitia hic.*/}
                    {/*</p>*/}
                </div>
                <div class="row g-4">
                    <div class="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.2s">
                        <div class="feature-item p-4">
                            <div class="feature-icon p-4 mb-4">
                                <i class="fas fa-chart-line fa-4x text-primary"></i>
                            </div>
                            <h4>Retail Investors</h4>
                            <p class="mb-4"> Manage and grow personal investments.Tracking and Benchmark comparison.
                            </p>
                            <a class="btn btn-primary rounded-pill py-2 px-4" href="#">Learn More</a>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.4s">
                        <div class="feature-item p-4">
                            <div class="feature-icon p-4 mb-4">
                                <i class="fas fa-university fa-4x text-primary"></i>
                            </div>
                            <h4>Financial Advisors</h4>
                            <p class="mb-4">Provide data-backed recommendations. Benefit of Advanced Research.
                            </p>
                            <a class="btn btn-primary rounded-pill py-2 px-4" href="#">Learn More</a>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.6s">
                        <div class="feature-item p-4">
                            <div class="feature-icon p-4 mb-4">
                                <i class="fas fa-file-alt fa-4x text-primary"></i>
                            </div>
                            <h4>Institutional Investors</h4>
                            <p class="mb-4"> Optimize large portfolios. Multiple Asset Class Support, Consolidated Performance and Risk Dashboard
                            </p>
                            <a class="btn btn-primary rounded-pill py-2 px-4" href="#">Learn More</a>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.8s">
                        <div class="feature-item p-4">
                            <div class="feature-icon p-4 mb-4">
                                <i class="fas fa-hand-holding-usd fa-4x text-primary"></i>
                            </div>
                            <h4>Quant Professionals</h4>
                            <p class="mb-4">Design Derivative Strategies, Advanced analytics, Analyze Scenarios and Optimize
                            </p>
                            <a class="btn btn-primary rounded-pill py-2 px-4" href="#">Learn More</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       {/* <!-- Features End -->*/}

      {/*<!-- About Start -->*/}

      <div class="container-fluid about py-5" id={"about_section"}>
            <div class="container py-5">
                <div class="row g-5 align-items-center">
                    <div class="col-xl-7 wow fadeInLeft" data-wow-delay="0.2s">
                        <div>
                            <h4 class="text-primary">About Us</h4>
                            <h1 class="display-5 mb-4">Empowering Smarter Financial Decisions with Advanced Analytics and Real-Time Insights</h1>
                            <p class="mb-4">From stock analysis to derivative pricing, fixed-income tools, and AI-driven portfolio management,
                                Orion Analytics delivers a unified platform for professionals to analyze, optimize, and grow wealth effortlessly
                            </p>
                            <div class="row g-4">
                                <div class="col-md-6 col-lg-6 col-xl-6">
                                    <div class="d-flex">
                                        <div><i class="fas fa-lightbulb fa-3x text-primary"></i></div>
                                        <div class="ms-4">
                                            <h4>Contact Us</h4>
                                            <p>Please write to us at below address.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-6 col-xl-6">
                                    <div className="d-flex">
                                        <i className="fas fa-phone-alt fa-2x text-primary me-4"></i>
                                        <div>
                                            <h4>Call Us</h4>
                                            <p className="mb-0 fs-5" style={{letterspacing: "1px"}}>+91 9861615950</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <a href="mailto:info@orionics.in" class="btn btn-primary rounded-pill py-3 px-5 flex-shrink-0">info@orionics.in</a>
                                </div>
                                <div class="col-sm-6">
                                    <div class="d-flex">
                                        {/*<i class="fas fa-phone-alt fa-2x text-primary me-4"></i>*/}
                                        <div>
                                            {/*<h4>Call Us</h4>*/}
                                            {/*<p class="mb-0 fs-5" style={{letterspacing: "1px"}}>+01234567890</p>*/}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-5 wow fadeInRight" data-wow-delay="0.2s">
                        <div class="bg-primary rounded position-relative overflow-hidden">
                            <img src={about2} class="img-fluid rounded w-100" alt=""/>
                            <div class="" style={{position: "absolute", top:"-15px", right:"-15px"}}>
                                <img src={about3} class="img-fluid" style={{width:"150px",height:"150px", opacity:"0.7"}} alt=""/>
                            </div>
                            <div class="" style={{position:"absolute", top:"-20px", left:"10px", transform: "rotate(90deg)"}}>
                                <img src={about4} class="img-fluid" style={{width:"100px",height:"150px", opacity:"0.9"}} alt=""/>
                            </div>
                            <div class="rounded-bottom">
                                <img src={about5} class="img-fluid rounded-bottom w-100" alt=""/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      </div>

      {/*<!-- About End -->*/}


      </div>
  );
}

export default HomePage;

